module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.saleState !== 3) ? _c('div', {
    staticClass: "ui left labeled fluid input"
  }, [_c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("\n      Send your eth to\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tokenAddress),
      expression: "tokenAddress"
    }],
    style: (_vm.termsAccepted ? '' : 'color:red'),
    attrs: {
      "type": "text",
      "readonly": "",
      "id": "tokenAddress"
    },
    domProps: {
      "value": (_vm.tokenAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tokenAddress = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('b', [_vm._v("DO NOT")]), _vm._v(" send ether from exchanges")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fc68baf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EthAddress.vue
// module id = 505
// module chunks = 1